import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import PropTypes from "prop-types";
import { useMemo } from "react";

import { Link } from "@transfr-inc/dashboard-components";

import { TransfrFeedbackForm } from "@models/links";
import { useCurrentUser } from "@queries/account";

export const FeedbackButton = ({ className, hideIcon }) => {
  const currentUser = useCurrentUser();

  const feedbackFormUrl = useMemo(() => {
    if (!currentUser) return "";
    return TransfrFeedbackForm.getUrl({
      orgCode: currentUser.organizationCode,
      email: currentUser.email,
    });
  }, [currentUser]);

  return (
    <Link
      className={clsx("btn small", className)}
      href={feedbackFormUrl}
      underline={false}
    >
      Feedback{" "}
      {!hideIcon && (
        <FontAwesomeIcon icon={["far", "arrow-up-right-from-square"]} />
      )}
    </Link>
  );
};

FeedbackButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.bool,
};
